import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
} from "reactstrap"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import moment from "moment"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

// import images
import iconPaymentSuccess from "assets/images/ugifts/icons/checkout/icon_payment_success.png"
import iconPaymentFailed from "assets/images/ugifts/icons/checkout/icon_payment_failed.png"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const PaymentStatus = props => {
  const query = useQuery()
  const history = useHistory()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [listType, setListType] = useState("active")
  const [oid, setOid] = useState(null)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    }

    if (query.get("id")) {
      setOid(query.get("id"))
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) {
      getOrderData()
      getFriendList()
      console.log("use effect")
    }
  }, [token, listType])

  const [orderData, setOrderData] = useState(null)
  const getOrderData = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_order")
    urlencoded.append("order_id", oid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request order", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_ORDER,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setOrderData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [searchData, setSearchData] = useState("")

  function onSubmitSearchField(e) {
    e.preventDefault()
    getFriendList()
  }

  function onChangeSearchField(e) {
    setSearchData(e.target.value)
  }

  const [friendData, setFriendData] = useState(null)
  const getFriendList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_friend")
    urlencoded.append("member_id", uid)
    if (searchData) urlencoded.append("filter_by_name", searchData)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request friend list", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setFriendData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [modal_sendToFriend, setmodal_sendToFriend] = useState(false)

  function tog_sendToFriend() {
    setmodal_sendToFriend(!modal_sendToFriend)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const onClickSendOrder = async recipient_id => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "send_order")
    urlencoded.append("member_id", uid)
    urlencoded.append("order_id", oid)
    urlencoded.append("recipient_id", recipient_id)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request send order", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_ORDER,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setUserData(postresponse.table)
      if (postresponse.success) {
        // setsuccess_dlg_noaction(true)
        // setdynamic_title("Send order success")
        // setdynamic_description(postresponse.message)
        getOrderData()
      }
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("Send Order Failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const [shareCodeMessage, setShareCodeMessage] = useState(
    props.t("Social Share")
  )
  const handleCopy = input => {
    const textField = document.createElement("textarea")
    textField.innerText = input
    document.body.appendChild(textField)
    textField.select()
    document.execCommand("copy")
    textField.remove()
    setShareCodeMessage(props.t("Copied"))
  }

  const [success_dlg, setsuccess_dlg] = useState(false)
  const [success_dlg_noaction, setsuccess_dlg_noaction] = useState(false)
  const [error_alert, seterror_alert] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            {success_dlg_noaction ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  setsuccess_dlg_noaction(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {success_dlg ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  history.push("/home")
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {error_alert ? (
              <SweetAlert
                title={dynamic_title}
                danger
                onConfirm={() => {
                  seterror_alert(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: "56px",
                  backgroundColor: "#F5F5F5",
                  paddingBottom: "76px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        {/* <Link to="/categories"> */}
                        {/* <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button> */}
                        {/* </Link> */}
                      </Col>
                      <Col xs={8} className="align-self-center">
                        <p className="h-100 text-white font-size-15 my-auto text-center">
                          {props.t("Payment Status")}
                        </p>
                      </Col>
                      <Col xs={2} className="pe-0">
                        {/* <Link to="#">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                          </Button>
                        </Link> */}
                      </Col>
                    </Row>
                    {orderData && orderData.products.length > 0 && (
                      <Row>
                        <Col>
                          <Card
                            className="shadow-none p-3 mb-0"
                            style={{ borderRadius: 0 }}
                          >
                            {orderData &&
                              orderData.payment_status == "Paid" &&
                              orderData.order_status != "Gifted" && (
                                <div>
                                  <Row className="justify-content-center">
                                    <Col xs="auto">
                                      <img
                                        src={iconPaymentSuccess}
                                        className="avatar-sm mt-2 mb-1"
                                        alt=""
                                        style={{
                                          maxWidth: "32px",
                                          maxHeight: "32px",
                                        }}
                                      />
                                    </Col>
                                    <Col
                                      xs="auto"
                                      className="align-self-center ps-0"
                                    >
                                      <span
                                        className="font-size-22"
                                        style={{
                                          fontWeight: 700,
                                          color: "#00BB66",
                                        }}
                                      >
                                        {props.t("Payment Success")}
                                      </span>
                                    </Col>
                                  </Row>
                                </div>
                              )}
                            {orderData &&
                              orderData.payment_status == "Paid" &&
                              orderData.order_status != "Gifted" && (
                                <Row>
                                  <Col>
                                    <Row className="justify-content-center px-3">
                                      <Col
                                        className="btn text-dark font-size-18"
                                        // style={{ height: "42px" }}
                                      >
                                        {props.t("Phrase of The Day")}
                                      </Col>
                                    </Row>
                                    <Row className="justify-content-center mb-3 px-3">
                                      <Col
                                        className="btn btn-outline-primary text-dark font-size-18"
                                        // style={{ height: "42px" }}
                                      >
                                        {orderData.phrase}
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              )}
                            {orderData &&
                              orderData.payment_status == "Paid" &&
                              orderData.order_status == "Gifted" && (
                                <div>
                                  <Row className="justify-content-center mb-3">
                                    <Col xs="auto">
                                      <img
                                        src={iconPaymentSuccess}
                                        className="avatar-sm mt-2 mb-1"
                                        alt=""
                                        style={{
                                          maxWidth: "32px",
                                          maxHeight: "32px",
                                        }}
                                      />
                                    </Col>
                                    <Col
                                      xs="auto"
                                      className="align-self-center ps-0"
                                    >
                                      <span
                                        className="font-size-22"
                                        style={{
                                          fontWeight: 700,
                                          color: "#00BB66",
                                        }}
                                      >
                                        {props.t("Sent Success")}
                                      </span>
                                    </Col>
                                  </Row>
                                  <Row className="justify-content-center">
                                    <Col
                                      xs="auto"
                                      className="align-self-center ps-0"
                                    >
                                      <span className="font-size-15 text-dark">
                                        {props.t(
                                          "Your gift was successfully sent to "
                                        ) +
                                          orderData.recipient_name +
                                          "!"}
                                      </span>
                                    </Col>
                                  </Row>
                                </div>
                              )}
                            {orderData &&
                              orderData.payment_status == "Pending" && (
                                <div>
                                  <Row className="justify-content-center">
                                    <Col xs="auto">
                                      <img
                                        src={iconPaymentFailed}
                                        className="avatar-sm mt-2 mb-1"
                                        alt=""
                                        style={{
                                          maxWidth: "32px",
                                          maxHeight: "32px",
                                        }}
                                      />
                                    </Col>
                                    <Col
                                      xs="auto"
                                      className="align-self-center ps-0"
                                    >
                                      <span
                                        className="font-size-22"
                                        style={{
                                          fontWeight: 700,
                                          color: "#E93C48",
                                        }}
                                      >
                                        {props.t("Payment Failed")}
                                      </span>
                                    </Col>
                                  </Row>
                                </div>
                              )}
                          </Card>
                        </Col>
                      </Row>
                    )}
                    {orderData &&
                      orderData.payment_status == "Paid" &&
                      orderData.order_status != "Gifted" &&
                      orderData.order_status != "Self-Use" && (
                        <Row className="p-3">
                          <Col>
                            <span
                              className="font-size-20 text-dark"
                              style={{ fontWeight: 500 }}
                            >
                              {props.t("Gift it to a friend")}
                            </span>
                          </Col>
                        </Row>
                      )}
                    {orderData &&
                      orderData.payment_status == "Paid" &&
                      orderData.order_status != "Gifted" &&
                      orderData.order_status != "Self-Use" && (
                        <Card
                          className="shadow-none p-3 mb-3"
                          style={{ borderRadius: 0 }}
                        >
                          <div>
                            <Row className="justify-content-center px-3">
                              <Col>
                                <Row className="pe-2">
                                  <button
                                    className="btn btn-danger waves-effect waves-light font-size-18"
                                    // style={{ height: "42px" }}
                                    onClick={() => {
                                      handleCopy(
                                        orderData.member_name +
                                          " sent you an e-gift card! Click to open your gift. https://sg.ugiftglobal.com/UgiftWeb/giftcard-share?id=" +
                                          oid
                                      )
                                    }}
                                  >
                                    {shareCodeMessage}
                                  </button>
                                </Row>
                              </Col>
                              <Col>
                                <Row className="ps-2">
                                  <button
                                    className="btn btn-danger waves-effect waves-light font-size-18"
                                    // style={{ height: "42px" }}
                                    onClick={tog_sendToFriend}
                                  >
                                    {props.t("Ugift Friends")}
                                  </button>
                                </Row>
                              </Col>
                            </Row>
                          </div>
                        </Card>
                      )}
                    <Row>
                      <Col>
                        <Card
                          className="shadow-none p-3 mb-0"
                          style={{ borderRadius: 0 }}
                        >
                          <div>
                            <Row className="justify-content-center mb-3 px-3">
                              <Link
                                to={"/order-details?id=" + oid}
                                className="btn btn-danger waves-effect waves-light font-size-18"
                                // style={{ height: "42px" }}
                              >
                                {props.t("View Order")}
                              </Link>
                            </Row>
                            <Row className="justify-content-center mb-3 px-3">
                              <Link
                                to={"/home"}
                                className="btn btn-outline-dark font-size-18"
                                // style={{ height: "42px" }}
                              >
                                {props.t("Back to Home")}
                              </Link>
                            </Row>
                          </div>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Modal
            isOpen={modal_sendToFriend}
            toggle={() => {
              tog_sendToFriend()
            }}
          >
            <div className="modal-header">
              <span className="modal-title mt-0" id="myModalLabel">
                {props.t("Send to friends")}
              </span>
              <button
                type="button"
                onClick={() => {
                  tog_sendToFriend()
                }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form
                className="app-search"
                style={{ padding: 0 }}
                onSubmit={onSubmitSearchField}
              >
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={"Search by name"}
                    // value={companyvaluesearch}
                    onChange={onChangeSearchField}
                    style={{
                      borderRadius: "8px",
                      maxHeight: "28px",
                    }}
                  />
                  <span
                    className="bx bx-search-alt"
                    style={{ lineHeight: "28px" }}
                  />
                </div>
              </form>
              {friendData &&
                friendData.map((data, index) => (
                  <Row>
                    <Col>
                      <Card
                        className="mb-0 shadow-none"
                        style={{
                          borderRadius: "0",
                          borderBottom: "1px",
                          borderBottomColor: "#D6D6D6",
                          borderBottomStyle: "solid",
                        }}
                      >
                        <Row className="p-3">
                          <Col xs="auto">
                            {data.friend_profile_picture ? (
                              <div className="avatar-xs mx-auto">
                                <img
                                  src={data.friend_profile_picture}
                                  className="rounded-circle avatar-xs"
                                  alt=""
                                />
                              </div>
                            ) : (
                              <div className="avatar-xs mx-auto">
                                <span
                                  className={
                                    "avatar-title rounded-circle bg-primary text-white font-size-16"
                                  }
                                >
                                  {data.friend_name &&
                                    data.friend_name.charAt(0)}
                                </span>
                              </div>
                            )}
                            {/* <div className="avatar-xs mx-auto">
                                    <img
                                      src={data.friend_profile_picture}
                                      className="rounded-circle avatar-xs"
                                      alt=""
                                    />
                                  </div> */}
                          </Col>
                          <Col className="align-self-center">
                            <span className="font-size-15 text-dark">
                              {data.friend_name}
                            </span>
                          </Col>
                          <Col xs="auto">
                            <button
                              className="btn btn-primary btn-rounded btn-sm"
                              onClick={() => {
                                onClickSendOrder(data.friend_id)
                                tog_sendToFriend()
                              }}
                            >
                              <span className="font-size-14 text-white">
                                {props.t("Send")}
                              </span>
                            </button>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                ))}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                onClick={() => {
                  tog_sendToFriend()
                }}
                className="btn btn-secondary waves-effect"
                data-dismiss="modal"
              >
                {props.t("Close")}
              </button>
              {/* <button
            type="button"
            className="btn btn-primary waves-effect waves-light"
          >
            Save changes
          </button> */}
            </div>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(PaymentStatus)

PaymentStatus.propTypes = {
  t: PropTypes.any,
}
